<template>
    <div class="defualt-box">
        <img class="defualt-img" :src="require('@/assets/images/common/default_page/default_img_bg.png')"/>
        <div class="defualt-title">{{mes}}</div>
    </div>
</template>
<script>
    export default {
        name: 'DefaultPage',
        props: {
            mes: {default: '暂无数据'},
        }
    }
</script>
<style lang="scss" scoped>
    .defualt-box {
        padding: 20px 0;
    }

    .defualt-img {
        margin: 0 auto;
        display: block;
    }

    .defualt-title {
        text-align: center;
        font-family: "\5B8B\4F53" !important;
        width: 80%;
        margin: 0 auto;
        font-size: 15px;
        line-height: 26px;
        color: #676A6C;
        word-wrap: break-word;
        word-break: break-all;
    }

</style>



// WEBPACK FOOTER //
// src/components/DefaultPage/index.vue